import MuiValidTextField from 'src/components/input/MuiValidTextField';
import { Field, useFormikContext } from 'formik';
import MuiRadioGroup from 'src/components/input/MuiRadioGroup';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReviewContext from 'src/store/review-page-context';
import { useContext } from 'react';
import AssociatedAccountsTable from 'src/components/AssociatedAccountsTable';
import { Link } from 'react-router-dom';

const ExemptionFormFields = ({ step1Href = './home' }) => {
  const { values } = useFormikContext();
  const { multipleAccts, ownerChg, busStatus } = values;
  const theme = useTheme();
  const { reviewInfo } = useContext(ReviewContext);
  const { review } = reviewInfo;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Field
          component={MuiRadioGroup}
          name="multipleAccts"
          label={'Is there more than one account associated with this legal entity in Utah County?'}
          row={true}
          itemValues={['Y', 'N']}
          itemLabels={['Yes', 'No']}
          sx={{ mb: '0.125rem' }}
        />
      </Grid>

      {multipleAccts === 'Y' && (
        <Grid item xs={12}>
          <Field
            name="associatedAcctInfo"
            component={MuiValidTextField}
            multiline
            rows={6}
            label={'Please list additional accounts here'}
            sx={{ width: '100%', my: '0.125rem' }}
            InputLabelProps={{ shrink: true }}
          />

          {review.associatedAccounts.length > 0 && (
            <>
              <Typography varient="body1">Associated accounts currently on file:</Typography>

              <Card sx={{ width: '100%', my: '0.125rem' }}>
                <CardContent>
                  <Typography
                    component="span"
                    sx={{ fontSize: '0.875rem' }}
                    color="text.secondary"
                    gutterBottom
                  ></Typography>
                  <AssociatedAccountsTable accounts={review.associatedAccounts} />
                </CardContent>
              </Card>
            </>
          )}
        </Grid>
      )}

      <Grid item xs={12}>
        <Field
          component={MuiRadioGroup}
          name="ownerChg"
          label={'Has the ownership of the business changed during the last year?'}
          row={true}
          itemValues={['Y', 'N']}
          itemLabels={['Yes', 'No']}
        />
      </Grid>
      {ownerChg === 'Y' && busStatus !== 'sold' && (
        <div
          style={{
            width: '100%',
            marginBottom: '.5rem',
            fontWeight: 'bold',
            color: `${theme.palette.primary.danger}`,
          }}
        >
          Please complete the sold business section on{' '}
          <Link to={step1Href} style={{ display: 'inline', textDecoration: 'underline' }}>
            Step 1
          </Link>
        </div>
      )}
      <Grid item xs={12}>
        <Field
          component={MuiRadioGroup}
          name="reqExempt"
          label={'Do you wish to apply for the Personal Property tax exemption?'}
          row={true}
          itemValues={['Y', 'N']}
          itemLabels={['Yes', 'No']}
        />
      </Grid>
    </Grid>
  );
};

export default ExemptionFormFields;
